var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"2em","height":"2em","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"fill":"#000000","d":"M11 13H5v-2h6V5h2v6h6v2h-6v6h-2z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }